import { keyframes as MUIKeyframes } from '@mui/material/styles'
import { type PaletteTypes } from './palette'
import type { BorderRadiusTypes } from './borderRadius/types'
import type { SemanticTokens } from './tokens/generated/types'
import type { Theme as AugmentedTheme } from './themeTypes'

export { createKuramaTheme, lightTheme, darkTheme, defaultTheme } from './createKuramaTheme'
export { default } from './createKuramaTheme'

export interface BaseTheme {
  /** @deprecated Use `theme.tokens.*`. Internal MUI bridge only — removed in next major. */
  palette: PaletteTypes
  borderRadius: BorderRadiusTypes
}

export const keyframes = MUIKeyframes
export type Theme = AugmentedTheme
export type { CSSObject, TypographyStyle, SxProps } from './themeTypes'
export type { ThemeMode } from './createPaletteBridge'
export type { SemanticTokens }
export {
  getNamedColorConfig,
  migrateNamedColor,
  namedColorIds,
  resolveNamedColor,
  selectableNamedColors
} from './namedColors'
export { getToken } from './tokens/getToken'
export { useToken } from './tokens/useToken'
export type { TokenPath } from './tokens/generated/types'
export type { NamedColor } from './namedColors'
export type { ThemeColor } from './palette'
export { zIndexes } from './zIndex'
export {
  DASHBOARD_BREAKPOINTS,
  DASHBOARD_MEDIA_QUERIES,
  DASHBOARD_GRID_SPACING,
  DASHBOARD_GRID_COLUMNS
} from './breakpoint'
